import React from 'react'
import * as S from "./tabsMeioFio_style"
import MeioFio from "../../imagens/meio fio_.jpg"

export default function TabsMeioFio() {
    return (
        <>
         <S.SectionGlobal>
                <S.SectionTabela>
                    <S.DivTabelaTitulo>
                        <p>Tipo</p>
                        <p>Medidas</p>
                        <p>Peças por m²</p>
                        <p>Peso</p>
                        <p>MPA</p>
                    </S.DivTabelaTitulo>
                    <S.DivTabelaConteudo>
                        <p>Meio Fio</p>
                        <p>12 x 13 x 30 x 80</p>
                        <p>1,25 peças</p>
                        <p>66 kg</p>
                        <p>35 a 50</p>
                    </S.DivTabelaConteudo>
                    <S.DivTabelaConteudo>
                        <p>Tento</p>
                        <p>10 x 25 x 80</p>
                        <p>2,5 peças</p>
                        <p>30 kg</p>
                        <p>35 a 50</p>
                    </S.DivTabelaConteudo>
                    <S.DivTabelaConteudo>
                        <p>Tento</p>
                        <p>09 x 19 x 39</p>
                        <p>2,5 peças</p>
                        <p>30 kg</p>
                        <p>35 a 50</p>
                    </S.DivTabelaConteudo>
                </S.SectionTabela>
                <S.ImgMeioFio src={MeioFio} alt="obra" />
            </S.SectionGlobal>
        </>
    )
}